import constants from '../constants/index';

const renderLoadingIndicator = state => {
  return state.appStatus !== constants.APP_STATUS.UNAUTHENTICATED &&
      state.appStatus !== constants.APP_STATUS.READY;
};

const renderAuthView = state => {
  return state.appStatus === constants.APP_STATUS.UNAUTHENTICATED;
};

const renderScheduleView = state => state.appStatus === constants.APP_STATUS.READY;

export default function appSelector(state) {

  return {
    renderLoadingIndicator: renderLoadingIndicator(state),
    renderAuthView: renderAuthView(state),
    renderScheduleView: renderScheduleView(state),
    hasErrors: state.errors.length > 0,
    modalIsOpen: state.modal.isOpen
  };

};


/** WEBPACK FOOTER **
 ** ./src/js/selectors/app_selector.js
 **/